<template>
    <div class="modal fade p-0" ref="popupHomePage" id="popup-home-page" tabindex="-1" role="dialog" aria-labelledby="exampleModalScrollableTitle" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg modal-xl" role="document">
        <div class="modal-content border-radius bg-primary">
          <div class="modal-header pt-0 pb-0 border-0">
            <div class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </div>
          </div>
          <div class="modal-body pt-0">
            <div class="container-fluid">
              <div class="row mb-2 mb-lg-3 mb-xl-3">
                <div class="col-12">
                  <h2 class="title">Đăng ký trở thành THỢ và nhận ngay một phần quà miễn phí!</h2>
                </div>
              </div>
              <div class="row no-gutters">
                <div class="col-lg-7">
                </div>
                <div class="col-lg-5">
                  <div class="pl-lg-5 mt-md-3 mt-lg-0">
                    <div>
                      Chỉ <span class="d-inline-block highlight">200 phần quà</span>
                    </div>
                    <div>
                      dành cho 200 người đăng ký trở thành Thợ
                      đầu tiên trên ODD JOB
                    </div>
                    <div class="font-weight-bold">
                      Hãy nhanh tay đăng ký nhé!!
                    </div>
                    <div class="signup-success pt-lg-4 pb-lg-4">
                      Sau khi bạn đã đăng ký thành công, Quản trị viên của ODD JOB sẽ duyệt tài khoản của bạn trong 48 giờ và chủ động liên hệ để trao quà.
                    </div>
                    <div class="pt-xl-4">
                      <a class="btn-register-provider btn border-secondary text-uppercase font-weight-bold text-white" href="providers">Đăng ký trở thành thợ ngay!</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="container-fluid">
              <div class="row mb-2 mb-lg-3 mb-xl-3">
                <div class="col-12">
                  <h4 class="question">Làm sao ODD JOB có thể giúp bạn tăng thêm thu nhập? Hãy tham gia hội thảo</h4>
                  <h2 class="answer">ODD JOB - Ứng dụng gọi THỢ công nghệ 4.0</h2>
                </div>
              </div>
              <div class="row">
                 <div class="col-lg-2 d-none d-lg-block">
                 </div>
                 <div class="col-12 pl-lg-2 pl-xl-5 col-lg-5">
                    <div class="time-and-place">
                        <div class="title font-weight-bold mb-1">Thời gian & địa điểm tổ chức:</div>
                        <div class="time row no-gutters mb-1">
                          <div class="col-auto">
                            <i class="far fa-clock" aria-hidden="true"></i>
                            Thời gian:
                          </div>
                          <div class="col-9 col-sm-8 col-xl-9 pl-1">
                             <b>9:00</b> sáng - <b>12:00</b> trưa <span class="d-inline-block">
                              thứ Bảy, ngày <b>22/08/2020</b></span>
                          </div>
                        </div>
                        <div class="place row no-gutters">
                          <div class="col-auto">
                            <i class="fas fa-location-arrow" aria-hidden="true"></i>
                              Địa điểm:
                          </div>
                          <div class="col pl-1">
                             79 Nguyễn Đình Chiểu, Phường 6, Quận 3, TP.HCM
                           </div>
                        </div>
                    </div>
                    <div class="content mt-3">
                      <div class="title mb-1 font-weight-bold">Nội dung chương trình:</div>
                       <ul class="list-content-group">
                         <li class="list-content-item">
                            <i class="far fa-check-circle" aria-hidden="true"></i>
                            Giới thiệu ứng dụng ODD JOB
                         </li>
                         <li class="list-content-item">
                            <i class="far fa-check-circle" aria-hidden="true"></i>
                            Tìm hiểu khả năng tăng thu nhập nếu sử dụng ODD JOB
                         </li>
                          <li class="list-content-item">
                            <i class="far fa-check-circle" aria-hidden="true"></i>
                            Dùng thử ứng dụng để trải nghiệm và cảm nhận rõ hơn
                         </li>
                         <li class="list-content-item">
                            <i class="far fa-check-circle" aria-hidden="true"></i>
                            Đăng ký tham gia ngay tại hội thảo, tài khoản đăng ký được kích hoạt ngay lập tức không phải chờ đợi.
                         </li>
                       </ul>
                    </div>
                 </div>
                 <div class="col-12 col-lg-5 mt-2 mt-lg-0">
                    <div class="registration">
                       <div class="title font-weight-bold mb-1">Đăng ký tham gia:</div>
                       <ul>
                         <li>
                            <i class="far fa-check-circle" aria-hidden="true"></i>
                            Tham gia hoàn toàn <b>miễn phí</b> và nhận quà tri ân từ ODD JOB
                         </li>
                         <li>
                            <i class="far fa-check-circle" aria-hidden="true"></i>
                            Đăng ký bằng 1 trong 2 cách sau:
                         </li>
                       </ul>
                       <div class="ml-lg-3 ml-xl-5">
                          <div class="row no-gutters">
                              <div class="col-auto">
                                  <b>Cách 1:</b>
                              </div>
                              <div class="col col-xl-9 pl-1">
                                <b>Nhập số điện thoại </b> vào khung bên dưới và chúng tôi sẽ liên hệ bạn sớm nhất có thể để hướng dẫn và xác nhận đặt chỗ.
                                <div class="mb-2 mt-1">
                                  <input ref="phoneNumber" maxlength="10" v-model="phoneNumber" class="input-phone-number form-control d-inline-block" type="text" placeholder="Nhập số điện thoại" name="phoneNumber">
                                  <div v-if="error" ref="subscribleError" :class="hasError ? 'text-danger': 'text-success'" class="d-inline-block pt-1">{{error}}</div>
                                  <button :disabled="!validated" type="submit" @click="createSubscriber()" class="btn submitPhoneNumber text-uppercase text-light btn-block mt-3 mb-4 mt-lg-2 mb-lg-0">Gửi ngay</button>
                                </div>
                              </div>
                          </div>
                          <div class="row no-gutters mt-1 mb-lg-2">
                              <div class="col-auto">
                                  <b>Cách 2:</b>
                              </div>
                              <div class="col pl-1">
                                  Gọi trực tiếp đến số <span class="d-inline-block"><b>Hotline: 028 3535 4030 </b></span> để được hướng dẫn và xác nhận đặt chỗ nhanh nhất.
                              </div>
                          </div>
                       </div>
                    </div>
                 </div>
              </div>
            </div> -->

            <!-- <div class="d-lg-none">
              <img class="img-fluid test" src="../assets/advertise-1.png" alt="advertise"/>
            </div> -->
          </div>
        </div>
      </div>
    </div>
</template>

<style lang="scss" scoped>

ul{
  list-style-type: none;
  padding: 0px;
  margin: 0px;
}
#popup-home-page{
  font-family: "Open Sans";
  line-height: 24px;
  color: black;

  .btn-register-provider{
    border-width: 2px;
    opacity: 1;
    background-color: black;
    padding: 11px 4px;
    border-radius: 16px;
    font-size: 13px;
    line-height: 22px;
    width: 100%;
    &:hover{
       opacity: 0.8;
    }
  }

  .border-radius{
     border-radius: 40px;
  }

  .close{
    opacity: 1;
    text-shadow: none;
    cursor: pointer;
    span{
      font-size: 50px;
    }
    &:hover{
      opacity: .5;
    }
  }

  .modal-body{
    background-image: url('~@/assets/advertise-1.png');
    background-repeat: no-repeat;
    // background-size: contain;
    background-size: 100%  200px;
    background-position-y: bottom;
    width: 100%;
    background-position-x: calc(100% - -65px);
    min-height: 540px;
    font-size: 16px;
    line-height: 23px;
    &::-webkit-scrollbar
    {
      width: 12px;
      background-color: #F5F5F5;
    }
    &::-webkit-scrollbar-thumb
    {
      -webkit-box-shadow: inset 0 0 6px	#0D3D56;
      background-color: black;
    }

    .title{
      font-size: 23px;
      font-weight: 800;
    }

    .highlight{
      font-weight: 800;
      font-size: 23px;
      line-height: 23px;
    }

    .signup-success{
      font-size: 12px;
      line-height: 18px;
      padding-top: 10px;
      padding-bottom: 8px;
    }

  }

}
@media screen and (min-width: 360px){
  #popup-home-page{
    .modal-body{
        .title{
          margin-bottom: 15px;
        }
        .signup-success{
          padding-top: 25px;
          padding-bottom: 25px;
        }
    }
  }
}

@media screen and (min-width: 500px){
  #popup-home-page{
    .modal-body{
         background-position-x: calc(100% - -96px);
         background-size: 100%  250px;
    }
  }
}


@media screen and (min-width: 992px){
  #popup-home-page{
    .btn-register-provider{
      font-size: 13px;
    }
    .modal-body{
      background-size: 100% 100%;
      background-position: left 0px;
      min-height: 450px;
      font-size: 16px;
      line-height: 30px;
      .title{
        font-size: 32px;
        margin-bottom: 0px;
      }

      .highlight{
        font-size: 30px;
        line-height: 24px;
      }

      .signup-success{
        padding-top: 0px;
        font-size: 14px;
        line-height: 24px;
        padding-bottom: 0px;
      }
    }
  }
}



@media screen and (min-width: 1200px){
  #popup-home-page{
    .btn-register-provider{
      font-size: 16px;
    }
    .modal-body{
      min-height: 540px;

      .title{
        font-size: 48px;
      }

      .highlight{
        font-size: 30px;
      }

    }
  }
}


// #popup-home-page{
//   font-family: "Open Sans";
//   line-height: 24px;
//   color: black;
//   .border-radius{
//      border-radius: 40px;
//   }
//   .close{
//     opacity: 1;
//     text-shadow: none;
//     cursor: pointer;
//     span{
//       font-size: 50px;
//     }
//     &:hover{
//       opacity: .5;
//     }
//   }
//   .modal-body{
//     min-height:540px;
//     font-size: 14px;
    
//     &::-webkit-scrollbar
//     {
//       width: 12px;
//       background-color: #F5F5F5;
//     }
//     &::-webkit-scrollbar-thumb
//     {
//       -webkit-box-shadow: inset 0 0 6px	#0D3D56;
//       background-color: black;
//     }

//     .question{
//       font-weight: bold;
//       font-size: 20px;
//     }
//     .answer{
//       font-weight: 800;
//       font-size: 28px;
//     }
//     .input-phone-number{
//       padding:20px;
//       height: 60px;
//     }
//     .submitPhoneNumber{
//       background-color: black;
//       border-color: black;
//       &:hover{
//         opacity: 0.8;
//       }
//       &:disabled,&[disabled]{
//         background-color: black;
//         border-color: black;
//         opacity: 0.7;
//       }
//     }
//   }
// }
// @media screen and (min-width: 992px){
//   #popup-home-page{
//     .modal-body{
//       background: url("../assets/advertise-1.png") no-repeat left;
//       background-size: 100% 100%;
//       .question{
//         font-size: 20px;
//       }
//       .answer{
//         font-size: 30px;
//       }
//     }
//   }
// }

// @media screen and (min-width: 1200px){
//   #popup-home-page{
//     .modal-body{
//       .question{
//         font-size: 24px;
//       }
//       .answer{
//         font-size: 48px;
//       }
//     }
//   }
// }
</style>

<script>
export default {
   data(){
      return{
        validated: false,
        error: "",
        hasError: true,
        regx:{
          phoneNumber: /(?:\s+|)((0|(?:(\+|)91))(?:\s|-)*(?:(?:\d(?:\s|-)*\d{9})|(?:\d{2}(?:\s|-)*\d{8})|(?:\d{3}(?:\s|-)*\d{7}))|\d{9})(?:\s+|)/
        },
        phoneNumber:""
      }
   },
   watch:{
     phoneNumber(value){
        this.validatePhoneNumber(value);
     }
   },
   methods: {
      validatePhoneNumber(value){
        if(value == null){
          this.error = this.$t("home.popup_home.successfully");
          return;
        }
        this.error = "";
        this.hasError = true;  
        if(this.regx.phoneNumber.test(value) == true){
          this.validated = true;
        }else{
          // this.error = "The field must be a valid phone number";
          this.error = this.$t("home.popup_home.error");
          this.$refs.phoneNumber.focus();
          this.validated = false;
          return;
        }
      },
      openPopupHomePage(){
          var $ = global.jQuery;
          $(this.$refs.popupHomePage).modal('show');
      },
      async createSubscriber(){
        try{
            if(this.phoneNumber){
              const { data: { code, message, results} } = await this.$store.$oddjob.customers.createSubscriber({ subscriber: this.phoneNumber, source: "hoi_thao"});
              console.log("results", results);
              console.log("code", code);
              console.log("message", message);
              if(code === "duplicated" && message != null){
                this.hasError = true;
                // this.error = "The email or phone number is already subscribe";
                this.error = this.$t("home.popup_home.duplicated");
                return;
              }
            }
            this.hasError = false;
            this.phoneNumber = null;
            this.validated = false;
        }catch (e) {
          console.log("API create subscriber failed", e);
        }
      }
   }
}
</script>